import { apiClient, ICollectionResponse } from '@/resources/upgrade/jsonapi-client';
import { IThinSubject } from '@/resources/upgrade/ThinSubjects';

export function thinSubjectsRootQueryOptions(pageSize = 4) {
  return {
    queryKey: ['thin-subjects', 'roots', pageSize],
    queryFn: async () => {
      // Collection endpoint - kitsu keeps { data, meta } wrapper
      const response = await apiClient.get<ICollectionResponse<IThinSubject>>('thin_subjects', {
        'filter[scope]': 'roots',
        'page[size]': String(pageSize),
      });

      return response.data;
    },
    staleTime: 1000 * 60 * 5,
  };
}
